import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=e3a23d22&scoped=true&"
import script from "./TagList.vue?vue&type=script&lang=js&"
export * from "./TagList.vue?vue&type=script&lang=js&"
import style0 from "./TagList.vue?vue&type=style&index=0&id=e3a23d22&lang=scss&scoped=true&"
import style1 from "./TagList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a23d22",
  null
  
)

export default component.exports